import Button from './Button';
import Input from './Input';
import './inputButton.scss';



import React from 'react';

interface IInputButton {
    type?: string;
    value: string;
    setValue: (value: string) => void;
    onBtnClick?: () => void;
    label: string;
    placeholder?: string;
}

export default function InputButton(props: IInputButton) {
    const label = props?.label || 'button';
    const type = props?.type || 'text';

    return (
        <div className='input-button'>
            <Input
                placeholder={props?.placeholder}
                type={type}
                value={props?.value}
                onChange={(value: string) => props?.setValue(value)}
                onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) =>
                    event.key === 'Enter' && props?.onBtnClick && props.onBtnClick()
                }
            />
            <Button
                label={label}
                onClick={() => props?.onBtnClick && props.onBtnClick()}
            />
        </div>
    );
}
